import { useEffect, useState } from "react";
import SwitchBox from "../../components/SwitchBox/SwitchBox";
import SearchInput from "../../components/SearchInput/SearchInput";
import Tab from "../../components/Tab/Tab";
import { IncompleteTable } from "./IncompleteTable";
import { PendingTable } from "./PendingTable";
import FilterBy from "../../components/FilterBy/FilterBy";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../axios/axios";
import {
  setFloorCaseFilter,
  setFloorCaseOngoingFilter,
} from "../../redux/slice/newFloorApplication";
import { toast } from "react-toastify";
import { generateDynamicData } from "./UserData";
import { OngoingTable } from "./OngoingTable";
import OngoingDetails from "./View/OngoingDetails";
import { RejectedTable } from "./RejectedTable";
import { useLocation } from "react-router-dom";

const accessToken = localStorage.getItem("dealerModuleToken");

export const DetailSummaryList = [
  { id: "", name: "All" },
  { id: "COE", name: "COE" },
  { id: "PARF", name: "PARF" },
  { id: "BODYONLY", name: "BODY ONLY" },
];

const DefaultFilter = {
  search_key: "",
  vehicle_type: "",
  is_active: 0,
  sortKey: "created_at",
  sortOrder: "2",
};
const DefaultOngoinFilter = {
  search_key: "",
  sortKey: "flooring_start_date",
  sortOrder: "2",
  is_active: 0,
  vehicle_type: "",
  is_repossess: "0",
};

const sortOptions = [
  { label: "Recent", value: "2" },
  { label: "Last 7 Days", value: "7" },
  { label: "Last 1 Month", value: "30" },
];
const Ongoingtabs = [
  { id: 0, name: "Ongoing" },
  { id: 1, name: "Repossessed" },
  { id: 'all', name: "All" },

];

const FlooringCases = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const flooringCaseFilter = useSelector(
    (state) => state?.newFloorApplication?.flooringCaseFileter
  );
  const flooringOngoingCaseFilter = useSelector(
    (state) => state?.floorCaseFilter?.flooringCaseOngoingFilters
  );
  const [applyFilters, setApplyFilters] = useState(
    flooringCaseFilter && Object.keys(flooringCaseFilter).length > 0
      ? { ...DefaultFilter, ...flooringCaseFilter }
      : DefaultFilter
  );
  const [ongoingFilters, setOngoingFilters] = useState(
    flooringOngoingCaseFilter &&
      Object.keys(flooringOngoingCaseFilter).length > 0
      ? { ...DefaultOngoinFilter, ...flooringOngoingCaseFilter }
      : DefaultOngoinFilter
  );
  const [searchValue, setSearchValue] = useState("");
  const [activeTab, setActiveTab] = useState(applyFilters?.is_active);
  const [sortByValue, setSortByValue] = useState(applyFilters?.sortOrder);
  const [FlooringCases, setFlooringCases] = useState([]);
  const [FlooringCasesCount, setFlooringCasesCount] = useState(
    flooringCaseFilter &&
      Object.keys(flooringCaseFilter).length > 0 &&
      flooringCaseFilter?.floorCount !== undefined
      ? { ...flooringCaseFilter?.floorCount }
      : {}
  );
  const [OngoingCases, setOngoingCases] = useState([]);
  const [OverallSummary, setOverallSummary] = useState({});

  const tabs = [
    `Incomplete (${FlooringCasesCount?.incomplete_count})`,
    `Pending (${FlooringCasesCount?.pending_count})`,
    `Ongoing (${OngoingCases?.length})`,
    "Rejected",
  ];

  if (location.state) {
    localStorage.setItem('floorpermissions', JSON.stringify(location.state));
  }

  let pagePermission = location.state || null;

  if (!pagePermission) {
    pagePermission = JSON.parse(localStorage.getItem('floorpermissions'));
  }


  const GetTabFilterValues = (tabId, key) => {
    if (Number(tabId) == 0) {
      return applyFilters[key];
    } else if (Number(tabId) == 1) {
      return applyFilters[key];
    } else if (Number(tabId) == 2) {
      return ongoingFilters[key];
    } else if (Number(tabId) == 3) {
      return applyFilters[key];
    } else {
      return "";
    }
  };

  const HandleFilters = (key, value) => {
    setApplyFilters({
      ...applyFilters,
      ...key,
    });
    dispatch(
      setFloorCaseFilter({
        ...applyFilters,
        ...key,
      })
    );
  };

  const HandleOngoingFilters = (obj) => {
    setOngoingFilters({
      ...ongoingFilters,
      ...obj,
    });
    dispatch(
      setFloorCaseOngoingFilter({
        ...ongoingFilters,
        ...obj,
      })
    );
  };

  const GetFlooringCases = async () => {
    const resp = await axios.post(`/flooring/application/list`, {
      ...applyFilters,
      is_active:
        applyFilters?.is_active == "3"
          ? ""
          : applyFilters?.is_active.toString(),
      sortOrder: applyFilters?.sortOrder == 2 ? "" : applyFilters?.sortOrder,
      sortKey: applyFilters?.sortOrder == 2 ? "created_at" : applyFilters?.sortKey,
    });
    if (resp.status < 400) {
      setFlooringCases(resp.data?.data?.applications);
      setFlooringCasesCount(resp.data?.data?.count);
      dispatch(
        setFloorCaseFilter({
          ...applyFilters,
          floorCount: resp.data?.data?.count,
        })
      );
    }
  };
  const GetFlooringOngoingCases = async () => {
    const resp = await axios.post(
      "flooring/application/OngoingList",
      {
        ...ongoingFilters,
        is_active:
          ongoingFilters?.is_active == 3 ? "" : ongoingFilters?.is_active,
        sortOrder:
          ongoingFilters?.sortOrder == 2 ? "" : ongoingFilters?.sortOrder,
        sortKey: ongoingFilters?.sortOrder == 2 ? "flooring_start_date" : ongoingFilters?.sortKey,
        is_repossess:
          ongoingFilters?.is_repossess === 'all' ? "" : ongoingFilters?.is_repossess,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (resp.status < 400) {
      setOngoingCases(resp.data?.data?.applications);
      setOverallSummary(resp.data?.data?.overall_summary);
    }
  };

  const DeleteFloorCases = async (appId) => {
    const resp = await axios.delete(`flooring/application/delete/${appId}`);
    if (resp.status < 400) {
      toast.success(resp.data?.message);
      GetFlooringCases();
    }
  };

  const handleSortBy = (label, value) => {
    setSortByValue(value);
    if (applyFilters?.is_active == 2) {
      HandleOngoingFilters({ sortOrder: value });
    } else {
      HandleFilters({ sortOrder: value });
    }
  };

  const handleSettingsChange = (idx, title, tabId) => {
    HandleFilters({ vehicle_type: tabId });
    if (applyFilters?.is_active == 2) {
      HandleOngoingFilters({ vehicle_type: tabId });
    } else {
      HandleFilters({ vehicle_type: tabId });
    }
  };

  const handleOngoingChange = (idx, title, tabId) => {
    if (applyFilters?.is_active == 2) {
      HandleOngoingFilters({ is_repossess: tabId });
    }
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    if (applyFilters?.is_active == 2) {
      HandleOngoingFilters({ search_key: e.target.value });
    } else {
      HandleFilters({ search_key: e.target.value });
    }
  };

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    HandleFilters({ is_active: tabIndex, sortOrder: "2" });
    HandleOngoingFilters({ sortOrder: "2" });
  };

  useEffect(() => {
    if (applyFilters?.is_active == 2) {
      GetFlooringOngoingCases();
    } else {
      GetFlooringCases();
    }
  }, [applyFilters, ongoingFilters]);

  useEffect(() => {
    GetFlooringOngoingCases();
    GetFlooringCases();
  }, []);

  return (
    <section className="common_container">
      <header className="common-header flex justify-between flex-wrap gap-4">
        <div className="common-header-body">
          <h1 className=" flex items-center gap-3">Flooring Cases</h1>
        </div>
      </header>
      <section>
        <div className="tab-section">
          <SwitchBox
            tabs={DetailSummaryList}
            settingsHandle={handleSettingsChange}
            value={GetTabFilterValues(applyFilters?.is_active, "vehicle_type")}
          />
          <div className="input-one-line search-block">
            <FilterBy
              defaultName="Filter"
              sortOptions={sortOptions}
              value={GetTabFilterValues(applyFilters?.is_active, "sortOrder")}
              handleSortBy={handleSortBy}
            />
            <SearchInput
              onChange={handleSearchChange}
              value={GetTabFilterValues(applyFilters?.is_active, "search_key")}
            />
          </div>
        </div>
        <div className="tab-section pt-4">
          <Tab
            tabs={tabs}
            activeTab={Number(applyFilters?.is_active)}
            onTabChange={handleTabChange}
          />
        </div>
        <div>
          {activeTab === 2 && OngoingCases?.length > 0 && (
            <>
              <div className="tab-section !border-b-0 pt-5">
                <SwitchBox
                  tabs={Ongoingtabs}
                  value={ongoingFilters?.is_repossess}
                  settingsHandle={handleOngoingChange}
                />
              </div>
              <OngoingDetails OverallSummary={OverallSummary} />
            </>
          )}
        </div>
        <div className="tab-body-section">
          <section className="table_section">
            {activeTab == 0 && (
              <IncompleteTable
                FlooringCases={FlooringCases}
                DeleteFloorCases={DeleteFloorCases}
                pagePermission={pagePermission}
              />
            )}
            {activeTab == 1 && (
              <PendingTable
                FlooringCases={FlooringCases}
                DeleteFloorCases={DeleteFloorCases}
                pagePermission={pagePermission}
              />
            )}
            {activeTab == 2 && <OngoingTable data={OngoingCases} pagePermission={pagePermission} />}
            {activeTab == 3 && <RejectedTable data={[]} pagePermission={pagePermission} />}
          </section>
        </div>
      </section>
    </section>
  );
};
export default FlooringCases;
